import React, { useState, useEffect, useCallback, useLayoutEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import CircularProgress from '@mui/material/CircularProgress';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Icon } from '@iconify/react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

import moment from 'moment';
import {
  Input,
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Typography,
  Table,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  Modal,
  Box,
  TextField,
  Divider,
  Grid,
  MenuItem,
  InputLabel,
  Select,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputAdornment,
  useTheme,
  Switch,
  Checkbox,
  Avatar,
  Badge,
  Skeleton
} from '@mui/material';

import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar/Scrollbar';
import { Api, UploadFile } from '../webservices';

const tablebg = 'rgba(82, 130, 190, 0.08)';
const filter = createFilterOptions();
function Trash() {

  const [tab, setTab] = useState("recprospect")
  const [loadingTab, setLoadingTab] = useState(false)
  const [tableData, setTableData] = useState([]);
  const [tableCount, setTableCount] = useState([])
  const [loading, setLoading] = useState([])
  const [pages, setPages] = useState(null);

  useLayoutEffect(() => {
    getResume()
  }, [])

  const getResume = (value) => {
    setLoadingTab(true)
    setTab('recprospect');
    setTableData([])
    setTableCount([])
    setLoading("Loading...")
    const token = localStorage.getItem('token');
    const body = {
      "page": value || 1,
      "limit": "35"
    }
    Api(`resume/getAllTrashResumes`, 'POST', body, token)
      .then((response) => {
        // console.log('=========get all resume======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading('')
            setTableCount(response.data.count)
            if (response.data.result.length !== 0) {
              // toast.success(response.data.message, +'!');
              setTableData(response.data.result || 0);
              const totalPage = Math.ceil(response.data.count / 35)
              setPages(totalPage)
              setLoadingTab(false)
            } else {
              setLoading('No Data Found')
              setTableData([]);

              // toast.warn('Data Not Found');
              setLoadingTab(false)
            }
          } else {
            setTableData([]);
            setLoading('No Data Found')
            // toast.warn(response.data.message);
            setLoadingTab(false)
          }
        } else {
          toast.warn(response.data.message, +'!');

        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const getResumeByStatus = (value) => {
    setLoadingTab(true)
    setTab('recsubmission');
    setTableData([])
    setTableCount([])
    setLoading("Loading...")
    const token = localStorage.getItem('token');
    const body = {
      "page": value || 1,
      "limit": "35",
      "status": "submitted"
    }
    Api(`resume/getTrashResumesByStatus`, 'POST', body, token)
      .then((response) => {
        // console.log('=========get all resume======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading('')
            setTableCount(response.data.count)
            if (response.data.data?.length !== 0) {
              // toast.success(response.data.message, +'!');
              setTableData(response.data?.data || 0);
              const totalPage = Math.ceil(response.data.count / 35)
              setPages(totalPage)
              setLoadingTab(false)
            } else {
              setLoading('No Data Found')
              setTableData([]);

              // toast.warn('Data Not Found');
              setLoadingTab(false)
            }
          } else {
            setTableData([]);
            setLoading('No Data Found')
            // toast.warn(response.data.message);
            setLoadingTab(false)
          }
        } else {
          toast.warn(response.data.message, +'!');

        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const getBenchByStatus = (value, type) => {
    setLoadingTab(true)
    // setTab('benchprospect');
    setTableData([])
    setTableCount([])
    setLoading("Loading...")
    const token = localStorage.getItem('token');
    const body = {
      "page": value || 1,
      "limit": "35",
      "status": type
    }
    Api(`bench/getAllTrashBenchDataByStatus`, 'POST', body, token)
      .then((response) => {
        console.log('=========get all resume======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading('')
            setTableCount(response.data.count)
            if (response.data.data?.length !== 0) {
              // toast.success(response.data.message, +'!');
              setTableData(response.data?.data || 0);
              const totalPage = Math.ceil(response.data.count / 35)
              setPages(totalPage)
              setLoadingTab(false)
            } else {
              setLoading('No Data Found')
              setTableData([]);
              // toast.warn('Data Not Found');
              setLoadingTab(false)
            }
          } else {
            setLoadingTab(false)
            setLoading('No Data Found')
            setTableData([]);
            // toast.warn(response.data.message);
            // alert("g")
          }
        } else {
          setLoadingTab(false)
          // toast.warn(response.data.message, +'!');

        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
        setLoadingTab(false)
      });
  };

  const getTrashedClients = (value) => {
    setLoadingTab(true)
    // setTab('benchprospect');
    setTableData([])
    setTableCount([])
    setLoading("Loading...")
    const token = localStorage.getItem('token');
    const body = {
      "page": value || 1,
      "limit": "35",
      "currentStatus": "new"
    }
    Api(`company/getTrashClient`, 'POST', body, token)
      .then((response) => {
        // console.log('=========get all resume======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading('')
            setTableCount(response.data.count)
            if (response.data.result?.length !== 0) {
              // toast.success(response.data.message, +'!');
              setTableData(response.data?.result || 0);
              const totalPage = Math.ceil(response.data.count / 35)
              setPages(totalPage)
              setLoadingTab(false)
            } else {
              setLoading('No Data Found')
              setTableData([]);

              // toast.warn('Data Not Found');
              setLoadingTab(false)
            }
          } else {
            setTableData([]);
            // toast.warn(response.data.message);
            setLoading('No Data Found')
            setLoadingTab(false)
          }
        } else {
          // toast.warn(response.data.message, +'!');

        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const getTrashedCompany = (value) => {
    setLoadingTab(true)
    // setTab('benchprospect');
    setTableData([])
    setTableCount([])
    setLoading("Loading...")
    const token = localStorage.getItem('token');

    Api(`company/trashCompany`, 'GET', '', token)
      .then((response) => {
        // console.log('=========get all resume======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading('')
            setTableCount(response.data.count)
            if (response.data.result?.length !== 0) {
              // toast.success(response.data.message, +'!');
              setTableData(response.data?.result || 0);
              const totalPage = Math.ceil(response.data.count / 35)
              setPages(totalPage)
              setLoadingTab(false)
            } else {
              setLoading('No Data Found')
              setTableData([]);

              // toast.warn('Data Not Found');
              setLoadingTab(false)
            }
          } else {
            setTableData([]);
            // toast.warn(response.data.message);
            setLoading('No Data Found')
            setLoadingTab(false)
          }
        } else {
          toast.warn(response.data.message, +'!');

        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const commonFun = () => {
    if (tab === "benchprospect") {
      getBenchByStatus('', "")
    } else if (tab === "recprospect") {
      getResume()
    } else if (tab === "benchsubmission") {
      getBenchByStatus('', "submitted")
    }
    else if (tab === "recsubmission") {
      getResumeByStatus()
    }
    else if (tab === "company") {
      getTrashedCompany()
    }
    else {
      getTrashedClients()
    }
  }

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteCond, setDeleteCond] = useState('');

  const handleOpenDeleteModal = (sts) => {
    setDeleteCond(sts)
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  // console.log("data", tableData)

  const [loadingMov, setLoadingMov] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});

  const handleCheck = (itemId) => {
    setCheckedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const isButtonDisabled = Object?.values(checkedItems)?.every(checked => !checked);

  const allChecked = tableData?.length > 0 && tableData?.every(item => checkedItems[item._id]);

  const handleSelectAll = () => {
    const newCheckedItems = tableData?.reduce((acc, item) => {
      acc[item._id] = !allChecked;
      return acc;
    }, {});

    setCheckedItems(newCheckedItems);
  };

  const deletForever = () => {
    setLoadingMov(true);

    const selectedIds = tableData
      ?.filter(item => checkedItems[item._id])
      .map(item => item._id);

    if (selectedIds.length > 0) {
      // commonDeleteTrash(selectedIds);

      if (deleteCond === "delete") {
        commonDeleteTrash(selectedIds)
      } else {
        commonUnTrash(selectedIds)
      } 

    } else {
      setLoadingMov(false);
      // toast.error("No items selected for deletion!");
    }
    setCheckedItems({});
  };

  //   const commonDel = (idArray) =>{
  // if(deleteCond === "delete"){
  // commonDeleteTrash(idArray)
  // } else {
  // commonUnTrash(idArray) 
  // }
  //   }

  const commonDeleteTrash = (idArray) => {
    let type;
    if (tab === "benchprospect") {
      type = "benchProspect"
    } else if (tab === "recprospect") {
      type = "resumeProspect"
    } else if (tab === "benchsubmission") {
      type = "benchSubmission"
    }
    else if (tab === "recsubmission") {
      type = "resumeSubmission"
    } else if (tab === "company") {
      type = "company"
    }
    else {
      type = "sales"
    }
    const body = {
      "from": type,
      "idArray": idArray
    }

    const token = localStorage.getItem('token');
    Api(`common/deleteTrash`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 200) {
            commonFun()
            handleCloseDeleteModal()
            setLoadingMov(false)
          } else {
            handleCloseDeleteModal()
            toast.error(response.data.message, +'!');
            setLoadingMov(false)
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const commonUnTrash = (idArray) => {
    let type;
    if (tab === "benchprospect") {
      type = "benchProspect"
    } else if (tab === "recprospect") {
      type = "resumeProspect"
    } else if (tab === "benchsubmission") {
      type = "benchSubmission"
    }
    else if (tab === "recsubmission") {
      type = "resumeSubmission"
    } else if (tab === "company") {
      type = "company"
    }
    else {
      type = "sales"
    }
    const body = {
      "from": type,
      "trashStatus": false,
      "idArray": idArray
    }

    const token = localStorage.getItem('token');
    Api(`common/unTrashData`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 200) {
            commonFun()
            handleCloseDeleteModal()
            setLoadingMov(false)
          } else {
            handleCloseDeleteModal()
            toast.error(response.data.message, +'!');
            setLoadingMov(false)
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  return (
    <>

      <Helmet>
        <title> Trash | Foxearch </title>
      </Helmet>
      <ToastContainer />
      <Stack direction="row" alignItems="flex-end" justifyContent="space-between">
        <Typography variant="h5" color="textSecondary">
          Trash Data
        </Typography>
      </Stack>

      <Stack sx={{ flexDirection: 'row', gap: 2, mb: 0.5, cursor: 'pointer', alignItems: 'center' }}>
        <Stack
          sx={[
            {
              flexDirection: 'row', alignItems: 'center',
              cursor: 'pointer',
            },
            tab === 'recprospect' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            getResume()
            setTab('recprospect');
          }}
        >
          <Iconify icon="mingcute:list-check-line" fontSize={18} />
          <Typography variant="tabs" sx={{}}>
            Recruiter Prospect
          </Typography>
        </Stack>

        <Stack
          sx={[
            {
              flexDirection: 'row', alignItems: 'center',
              cursor: 'pointer',
            },
            tab === 'recsubmission' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            getResumeByStatus()
            setTab('recsubmission');
          }}
        >
          <Iconify icon="mingcute:list-check-line" fontSize={18} />
          <Typography variant="tabs" sx={{}}>
            Recruiter Submission
          </Typography>
        </Stack>

        <Stack
          sx={[
            {
              flexDirection: 'row', alignItems: 'center',
              cursor: 'pointer',
            },
            tab === 'salesnew' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            setTab('salesnew');
            getTrashedClients()
          }}
        >
          <Iconify icon="mingcute:list-check-line" fontSize={18} />
          <Typography variant="tabs" sx={{}}>
            Sales Worksheet
          </Typography>
        </Stack>

        <Stack
          sx={[
            {
              flexDirection: 'row', alignItems: 'center',
              cursor: 'pointer',
            },
            tab === 'benchprospect' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            getBenchByStatus('', '')
            setTab('benchprospect');
          }}
        >
          <Iconify icon="mingcute:list-check-line" fontSize={18} />
          <Typography variant="tabs" sx={{}}>
            Bench Prospect
          </Typography>
        </Stack>

        <Stack
          sx={[
            {
              flexDirection: 'row', alignItems: 'center',
              cursor: 'pointer',
            },
            tab === 'benchsubmission' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            getBenchByStatus('', "submitted")
            setTab('benchsubmission');
          }}
        >
          <Iconify icon="mingcute:list-check-line" fontSize={18} />
          <Typography variant="tabs" sx={{}}>
            Bench Submission
          </Typography>
        </Stack>

        <Stack
          sx={[
            {
              flexDirection: 'row', alignItems: 'center',
              cursor: 'pointer',
            },
            tab === 'company' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            getTrashedCompany()
            setTab('company');
          }}
        >
          <Iconify icon="mdi:company" fontSize={18} />
          <Typography variant="tabs" sx={{ ml: 0.1 }}>
            Company
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ ml: 'auto', mb: 0.6 }}>
          <Button color="custom" variant="contained" size="small"
            onClick={() => handleSelectAll()}
          >
            {allChecked ? "Deselect All" : "Select All"}
            {/* Select all */}
          </Button>
          <Button color="custom" variant="contained" size="small"
            // sx={{color:"red"}}
            onClick={() => handleOpenDeleteModal('restore')}
          >
            Restore
          </Button>
          <Button color="custom" variant="contained" size="small"
            // sx={{color:"red"}}
            onClick={() => handleOpenDeleteModal('delete')}
          >
            Delete
          </Button>
        </Stack>
      </Stack>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            {["recsubmission", "recprospect"].includes(tab) ? (
              <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: "13%" }}>Date</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '16%' }}>Detail</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '17%' }}>Contact Details</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '16%' }}>Skills</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>Visa & Terms</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>Status</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: "8%" }}>Job Info</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: "5%" }}>Action</TableCell>
              </TableRow>
            ) : tab === "salesnew" ? (
              <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '16%' }}>Date</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '18%' }}>Detail</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '20%' }}>Contact Details</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '15%' }}>Location</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Activities</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>Status</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Action</TableCell>
              </TableRow>
            ) : ["benchprospect", "benchsubmission"].includes(tab) ? (
              <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Date</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '17%' }}>
                  {tab === "benchsubmission" ? "Candidate Details" : "Detail"}
                </TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '17%' }}>
                  {tab === "benchsubmission" ? "Summary" : "Contact Details"}
                </TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}>
                  {tab === "benchsubmission" ? "Client Details" : "Skills"}
                </TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}>
                  {tab === "benchsubmission" ? "Job Info" : "Visa & Terms"}
                </TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>
                  {tab === "benchsubmission" ? "Recruiter's Details" : "Summary"}
                </TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Status</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Action</TableCell>
              </TableRow>
            ) : tab === "company" ? (
              <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: "10%" }}>Company Name</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>Official Domain</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>Total Users</TableCell>
                <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>Action</TableCell>

              </TableRow>
            ) : (
              null
            )
            }
          </TableHead>

          <TableBody>
            {Array.isArray(tableData) &&
              tableData.map((item, index) => (
                <ResumeRow
                  key={item._id}
                  index={index}
                  row={item}
                  filterTab={tab}
                  checked1={checkedItems[item._id]}
                  handleCheck1={() => handleCheck(item._id)}
                  commonFun={commonFun}
                />
              ))}

          </TableBody>
        </Table>
      </TableContainer>
      {loading === "Loading..." ? (
        <Stack>
          {Array.from({ length: 15 })?.map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                height: 80,
                width: '100%',
                backgroundColor: index % 2 === 0 ? 'text.background' : tablebg,
              }}
            />
          ))}
        </Stack>

      ) :
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>
            {loading}

          </Typography>
        </Stack>
      }

      <Modal open={deleteModalOpen} onClose={handleCloseDeleteModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '50%', md: '40%' },
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            bgcolor: 'background.paper',
          }}
        >
          <Typography variant="h6" color = {deleteCond === "delete" ? "red" :" #3C6BA5"} textAlign="center">
            Are you sure you want to {deleteCond} selected data(s)?
          </Typography>

          <Stack
            flexDirection={{ xs: 'column', md: 'row' }}
            gap={2}
            mt={2}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 

              onClick={() => deletForever()}
              disabled={loadingMov || isButtonDisabled}

            >
              {loadingMov ? <CircularProgress size={24} /> : 'Yes'}
            </Button>
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={handleCloseDeleteModal}
            >
              No
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>

  );
}

export default Trash;

function ResumeRow({ row, filterTab, index, checked1, handleCheck1, commonFun }) {

  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);

  const [openn1, setOpenn1] = useState(false);
  const handleOpenn1 = () => setOpenn1(true);
  const handleClosen1 = () => setOpenn1(false);

  const selectCheckBox = (id) => {
    // setCheckRow(row)
    handleCheck1(id)
  }

  const [openn, setOpenn] = useState(false);
  const [his, setHis] = useState([]);
  const handleOpenn = () => {
    setOpenn(true);
    getHis();
  };

  const getHis = () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_history/${filterTab === 'recprospect' ? row._id : row.resumeId}`, 'GET', '', token)
      .then((response) => {
        // console.log('==========get_history=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setHis(response.data.data);
            // setJoblst(response.data.data);
          }
        }
      })
      .catch((err) => { });
  };
  const handleClosen = () => setOpenn(false);

  const [openclient, setOpenclient] = useState(false);
  const handleOpenclient = () => setOpenclient(true);
  const handleCloseclient = () => setOpenclient(false);

  const [phoneCopy, setPhoneCopy] = useState(false);
  const [emailCopy, setEmailCopy] = useState(false);
  const [client, setClients] = useState([]);
  const [newSkill, setNewSkill] = useState([])

  const getClients = async () => {
    const token = localStorage.getItem('token');
    let id;
    if (filterTab === 'recprospect') {
      id = row._id
    }
    else {
      id = row.resumeId
    }
    // console.log("==========id", id)

    Api(`resume/get_history/${id}`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========get_client_for_resume======>>>>>>>', response);
          if (response.data.code === 200) {
            setClients(response.data.data);
            // console.log('client========', JSON.stringify(response.data));
            handleOpenclient();
          } else {
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const [openclient11, setOpenclient11] = useState(false);
  const handleOpenclient11 = () => setOpenclient11(true);
  const handleCloseclient11 = () => setOpenclient11(false);
  const [clients11, setClients11] = useState([])

  const getClientsBench = async () => {
    const token = localStorage.getItem('token');

    let id;
    if (filterTab === "benchprospect") {
      id = row._id
    } else {
      id = row.benchId
    }
    // console.log("==========id==========", id)
    const body = {
      "bench_id": id,
    }
    // Api(`resume/get_history/${id}`, 'GET', '', token)
    Api(`bench/getBenchActivityList`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          setClients11(response.data.result);
          if (response.data.code === 200) {
            setClients11(response.data.result);
            handleOpenclient11();
          } else {
            handleOpenclient11();
            // toast.error(response.data.message, +'!');
          }
        } handleOpenclient11();
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const styleSkillset = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: { xs: '60%', sm: '50%' },
    width: '50%',
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleSkillset11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    //     paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  const styleClients = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: { xs: 2, sm: 3 },
    borderRadius: 3,
  };

  const styleClients1 = {
    height: '90%',
    position: 'absolute',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '65%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const [openRes, setOpenRes] = useState('');
  const [openR, setOpenR] = useState(false);
  const openResume = (resUrl) => {
    setOpenRes(resUrl)
    setOpenR(true);
  };
  const closeResume = () => {
    setOpenR(false);
  };

  const [levelM, setLevelM] = useState(false);
  const [openclient1, setOpenclient1] = useState(false);
  const [updateSummary, setUpdateSummary] = useState('')
  const handleCloseclient1 = () => setOpenclient1(false);

  const [opens11, setOpens11] = useState(false)
  const handleOpens11 = () => setOpens11(true);
  const handleCloses11 = () => setOpens11(false);

  const [opens1, setOpens1] = useState(false);
  const handleOpens1 = () => {
    setOpens1(true);
  }
  const handleCloses1 = () => setOpens1(false);

  const handleOpenclient1 = (row) => {
    setUpdateSummary(row.summary);
    setOpenclient1(true)

  }

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [sts, setSts] = useState('')

  const handleOpenDeleteModal = (sts) => {
    setSts(sts)
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
    setSts('')
  };

  const [delSts, setDelSts] = useState(false)

  const commonDelete = (id) => {
    if (sts === "delete") {
      commonDeleteTrash(id)
    } else {
      commonUnTrash(id)
    }
  }

  const commonDeleteTrash = (id) => {
    let type;
    if (filterTab === "benchprospect") {
      type = "benchProspect"
    } else if (filterTab === "recprospect") {
      type = "resumeProspect"
    } else if (filterTab === "benchsubmission") {
      type = "benchSubmission"
    }
    else if (filterTab === "recsubmission") {
      type = "resumeSubmission"
    } else if (filterTab === "company") {
      type = "company"
    }
    else {
      type = "sales"
    }

    const body = {
      "from": type,
      "idArray": [id]
    }

    const token = localStorage.getItem('token');
    Api(`common/deleteTrash`, 'POST', body, token)
      .then((response) => {
        console.log("res===>>", response)
        if (response.status === 200) {
          if (response.data.status === 200) {
            toast.success(response.data.resmessage);
            handleCloseDeleteModal()
            commonFun()
          } else {
            handleCloseDeleteModal()
            toast.error(response.data.resmessage);
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const commonUnTrash = (id) => {
    let type;
    if (filterTab === "benchprospect") {
      type = "benchProspect"
    } else if (filterTab === "recprospect") {
      type = "resumeProspect"
    } else if (filterTab === "benchsubmission") {
      type = "benchSubmission"
    }
    else if (filterTab === "recsubmission") {
      type = "resumeSubmission"
    } else if (filterTab === "company") {
      type = "company"
    }
    else {
      type = "sales"
    }

    const body = {
      "from": type,
      "idArray": [id],
      "trashStatus": false,
    }

    const token = localStorage.getItem('token');
    Api(`common/unTrashData`, 'POST', body, token)
      .then((response) => {
        console.log("res===>>", response)
        if (response.status === 200) {
          if (response.data.status === 200) {
            toast.success(response.data.resmessage);
            handleCloseDeleteModal()
            commonFun()
          } else {
            handleCloseDeleteModal()
            toast.error(response.data.resmessage);
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  return (
    <>
      {["recsubmission", "recprospect"].includes(filterTab) ? (
        <TableRow
          key={row._id}
          sx={[
            { background: index % 2 === 0 ? 'text.background' : tablebg },
            { '&:last-child td, &:last-child th': { border: 0 } },
            { '&:hover': { boxShadow: 5 } },
          ]}
        >
          {filterTab === 'recprospect' && (
            <TableCell sx={{ py: 0 }}>
              <Stack sx={{ flexDirection: "row" }}>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked1 || false}
                      onChange={() => selectCheckBox(row?._id)}
                    />
                  }
                  label=""
                />
                <Stack sx={{ flexDirection: "column", ml: -2 }}>
                  <Typography sx={{}} >

                    Up - {`${new Date(row.updatedAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(row?.updatedAt)?.getHours())?.padStart(2, '0')}`}:{`${String(new Date(row?.updatedAt)?.getMinutes())?.padStart(2, '0')}`}
                  </Typography>

                  <Typography sx={{}}>
                    Cr - {`${new Date(row.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(row?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(row?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                  </Typography>
                  <Typography>-</Typography>
                </Stack>
              </Stack>
            </TableCell>
          )}

          {filterTab === 'recsubmission' && (
            <TableCell sx={{ py: 0 }}>
              <Stack sx={{ flexDirection: "row" }}>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked1 || false}
                      onChange={() => selectCheckBox(row?._id)}
                    />
                  }
                  label=""
                />
                <Stack sx={{ flexDirection: "column", ml: -2 }}>

                  <Typography sx={{}}>

                    Cr - {`${new Date(row.createdAt).toLocaleString('en-US', optionsDate)} 
    ${String(new Date(row?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(row?.createdAt).getMinutes()).padStart(2, '0')}`}
                  </Typography>

                  <Typography> -</Typography>
                  <Typography> -</Typography>
                </Stack>
              </Stack>
            </TableCell>
          )}

          <TableCell sx={{ py: 0 }}>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              {row.userStatus === 'fake' || row.userStatus === 'blacklisted' ? (
                <Typography
                  sx={{ fontWeight: '600', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.9rem' }}
                  color={'red'}

                >
                  {row.fullName}
                </Typography>
              ) : (filterTab === 'recprospect' && row.status === 'started') || row.status === 'placement' ? (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '0.9rem'
                  }}
                  color={'#2ECC71'}

                >
                  {row.fullName}
                </Typography>
              ) : (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '0.9rem'
                  }}
                  color={'text.secondary'}

                >
                  {(row.fullName) ? row.fullName : "#"}
                </Typography>
              )}
              <Iconify
                icon="devicon:linkedin"
                color={'text.textG'}

                sx={{
                  m: 0.3, height: 15, width: 15, cursor: 'pointer',
                }}
                hover
                onClick={() => window.open(row.linkedinUrl, '_blank')}

              />
              <Iconify
                icon="cuida:document-text-outline"
                color="#1E74B3"
                sx={{
                  ml: 0.6, height: 18, width: 18,
                  cursor: 'pointer'
                }}
                hover
                onClick={() => openResume(row.resumeUrl)}
              />
            </Stack>
            <Typography sx={{ width: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} >
              {row.jobTitle ? row.jobTitle : "-"}

            </Typography>
            <Typography sx={{ width: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'text.textG'}>
              {/* {row.currentCompany ? row.currentCompany : '-'} */}
              {(row?.currentCompany || '').trim() || '-'}
            </Typography>
          </TableCell>

          <TableCell sx={{ py: 0 }}>
            {row.phone ? (
              <Stack sx={{ flexDirection: 'row' }}>

                <Typography sx={{ flexDirection: 'row', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {
                    row?.phone?.trim()
                      ? row?.phone?.trim()
                        ?.replace(/\s+/g, '')
                        ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                          if (p1) {
                            const countryCode = p1;
                            const lastDigits = p2?.slice(-10);
                            return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                          }
                          return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                        })
                      : ''
                  }
                </Typography>

                <CopyToClipboard text=
                  {
                    row?.phone?.trim()
                      ? row?.phone?.trim()
                        ?.replace(/\s+/g, '')
                        ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                          if (p1) {
                            const countryCode = p1;
                            const lastDigits = p2?.slice(-10);
                            return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                          }
                          return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                        })
                      : ''
                  }
                  onCopy={() => setPhoneCopy(true)}>
                  <Iconify
                    icon="radix-icons:copy"
                    color={phoneCopy ? 'text.secondary' : 'text.textG'}
                    sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                    hover
                  />
                </CopyToClipboard>
              </Stack>
            ) : (
              <Typography>-</Typography>
            )}
            {row.email ? (
              <Stack sx={{ flexDirection: 'row' }}>
                <Typography
                  sx={{ textTransform: 'lowercase', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                  {row.email}
                </Typography>
                <CopyToClipboard text={row.email} onCopy={() => setEmailCopy(true)}>
                  <Iconify
                    icon="radix-icons:copy"
                    color={emailCopy ? 'text.secondary' : 'text.textG'}
                    sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                  />
                </CopyToClipboard>
              </Stack>
            ) : (
              <Typography>-</Typography>
            )}
            {row.city || row.stateCode || row.reallocate === 'yes' ? (
              <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <Typography sx={{}} color={'text.textG'}>
                  {row.city ? row.city : null},
                </Typography>
                <Typography sx={{}} color={'text.textG'}>
                  {row.stateCode ? row.stateCode : null}
                </Typography>

                {row.reallocate === 'yes' ? (
                  <Iconify icon="mdi:aeroplane" fontSize={20} color={'text.secondary'} />
                ) : null}
              </Stack>
            ) : (
              <Typography color={'text.textG'}>-</Typography>
            )}
          </TableCell>
          <TableCell sx={{ py: 0, width: 170 }}>
            {row.skill && row.skill?.length > 0 ? (
              <Grid container sx={{ maxWidth: 160, height: 44, overflow: 'hidden', textOverflow: 'ellipsis', gap: 0.3 }}>
                {row.skill?.map((item, index) => (
                  item && (
                    <Typography key={index} sx={{}}>
                      {item}
                      {index < row.skill.filter(skill => skill).length - 1 && ' | '}
                    </Typography>
                  )
                ))}
              </Grid>
            ) : (
              <Typography>-</Typography>
            )}
            {row.skill && row.skill?.length > 0 ? (
              <Typography
                sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => {
                  handleOpens();
                  setNewSkill(row.skill)
                }}

              >
                view all
              </Typography>
            ) : null}
          </TableCell>

          <TableCell sx={{ py: 0, width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Typography sx={{}}>{row.visaType ? row.visaType : '-'}</Typography>

            <Typography sx={{ textTransform: "capitalize" }} color={'text.textG'}>
              {row.taxTerm ? row.taxTerm : '-'}
            </Typography>
          </TableCell>
          <TableCell sx={{ py: 0, width: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}>

            {filterTab === 'recsubmission' ? (
              <Typography sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}

              >
                {row.tempSubmitStatus !== "" && row.status === "submitted" ? row.tempSubmitStatus : row.status}
              </Typography>
            ) : null}
            {filterTab === 'recprospect' || filterTab === 'recsubmission'
              ? (
                <Stack sx={{ flexDirection: 'row', gap: 0.5 }}>
                  <Typography sx={{}} >
                    {row.jobId}
                  </Typography>
                  <Stack sx={{ flexDirection: 'row' }} onClick={(e) => getClients()}>
                    <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
                    <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>

                      {row.clients ? `+ ${row.clients}` : ''}
                    </Typography>
                  </Stack>
                </Stack>
              ) : (
                <Typography sx={{}}>
                  {row.jobId ? row.jobId : '-'}
                </Typography>
              )}

            <Stack sx={{ flexDirection: "row" }}>

              <Typography sx={{}} color={'text.textG'}>
                {row.contactPersonName ? row.contactPersonName : '-'}
              </Typography>

              {row?.dataFrom === "foxearchdb" && (

                <Avatar sx={{
                  cursor: 'pointer', width: "18px", height: "18px", ml: 1,
                  // position:"absolute"
                  mb: -0.5
                }} src="/assets/FoxearchLogo.png" />
              )}
            </Stack>

          </TableCell>

          <TableCell sx={{ width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Typography sx={{}}>
              {row.clientName && row?.clientName.length > 17 ? `${row?.clientName?.slice(0, 17)}...` : row.clientName || '-'}
            </Typography>

            {filterTab === 'recprospect' ? (
              <Typography sx={{}}>
                {row.jobIdTitle?.length > 20
                  ? `${row.jobIdTitle.slice(0, 20)}...`
                  : row.jobIdTitle}
              </Typography>
            ) : (
              <Typography sx={{}}>
                {row.type === 'position' ? (
                  row.jobIdTitle?.length > 20
                    ? `${row.jobIdTitle.slice(0, 20)}...`
                    : row.jobIdTitle
                ) : (
                  row.positionName?.length > 20
                    ? `${row.positionName.slice(0, 20)}...`
                    : row.positionName
                )}
              </Typography>
            )}

            <Typography
              sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={handleOpenn}
            >
              notes
            </Typography>
          </TableCell>

          <TableCell>
            <Typography sx={{ color: 'text.secondary', cursor: 'pointer', fontWeight: "bold" }} onClick={() => handleOpenDeleteModal('restore')}>Restore</Typography>
            <Typography sx={{ color: "red", cursor: 'pointer' }} onClick={() => handleOpenDeleteModal('delete')}>Delete</Typography>
            <Typography>-</Typography>
          </TableCell>
        </TableRow>
      ) : filterTab === "salesnew" ? (
        <TableRow
          key={row._id}
          sx={[
            { background: index % 2 === 0 ? 'text.background' : tablebg },
            { '&:last-child td, &:last-child th': { border: 0 } },
            { '&:hover': { boxShadow: 5 } },
          ]}
        >
          <TableCell sx={{ py: 0 }}>
            <Stack sx={{ flexDirection: "row" }}>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked1 || false}
                    onChange={() => selectCheckBox(row?._id)}
                  />
                }
                label=""
              />
              <Stack sx={{ flexDirection: "column", ml: -2 }}>
                <Typography sx={{}}>

                  Up - {`${new Date(row.updatedAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(row?.updatedAt).getHours()).padStart(2, '0')}`}:{`${String(new Date(row?.updatedAt).getMinutes()).padStart(2, '0')}`}
                </Typography>
                <Typography sx={{}}>

                  Cr - {`${new Date(row.createdAt).toLocaleString('en-US', optionsDate)} 
    ${String(new Date(row?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(row?.createdAt).getMinutes()).padStart(2, '0')}`}
                </Typography>
                <Stack sx={{ flexDirection: 'row' }}>
                  <Typography
                  >
                    -
                  </Typography>

                </Stack>
              </Stack>
            </Stack>
          </TableCell>
          <TableCell
            sx={{ py: 0 }}
          >
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              {row.currentStatus === 'dnc' ? (
                <Typography sx={{ fontWeight: '600', cursor: 'pointer', maxWidth: 170, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'red'}>
                  {row.companyName}
                </Typography>
              ) : (
                <Typography
                  sx={{ fontWeight: '600', cursor: 'pointer', maxWidth: 170, overflow: 'hidden', textOverflow: 'ellipsis' }}
                  color={'text.secondary'}
                >
                  {row.companyName}
                </Typography>
              )}
              <Iconify
                icon="mdi:web"
                color={'text.textB'}
                sx={{ m: 0.3, height: 15, width: 15, cursor: 'pointer' }}
                hover
                onClick={() => window.open(row.websiteUrl, '_blank')}
              />
            </Stack>
            {row.contactPersonName ? (
              <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                <Typography sx={{ maxWidth: 170, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.contactPersonName}</Typography>
                <Iconify
                  icon="devicon:linkedin"
                  color={'text.textG'}
                  // color={row.linkedinUrl ? 'text.textG' : 'text.disabled'}
                  sx={{ m: 0.3, height: 15, width: 15, cursor: 'pointer' }}
                  hover
                  onClick={() => window.open(row.linkedinUrl, '_blank')}
                // onClick={() => {
                //   if (row.linkedinUrl) {
                //     window.open(row.linkedinUrl, '_blank');
                //   }
                // }}
                />
              </Stack>
            ) : (
              <Typography sx={{}} color={'text.textG'}>
                -
              </Typography>
            )}

            <Typography
              //  sx={{ textTransform: 'uppercase' }} 
              color={'text.textG'}>
              {row.RPO_Staffing || '-'}
            </Typography>

          </TableCell>
          <TableCell sx={{ py: 0 }}>
            <Typography sx={{ textTransform: 'none' }}>{row.designation || '-'}</Typography>
            {row.email ? (
              <Stack sx={{ flexDirection: 'row' }}>
                <Typography sx={{ textTransform: 'lowercase', maxWidth: 170, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.email}</Typography>
                <CopyToClipboard text={row.email} onCopy={() => setEmailCopy(true)}>
                  <Iconify
                    icon="radix-icons:copy"
                    color={emailCopy ? 'text.secondary' : 'text.textG'}
                    sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                  />
                </CopyToClipboard>
              </Stack>
            ) : (
              <Typography sx={{ textTransform: 'lowercase' }} color={'text.textG'}>
                -
              </Typography>
            )}

            {row.contactNoWithISD ? (
              <Stack sx={{ flexDirection: 'row' }}>
                <Typography sx={{ maxwidth: 170, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'text.textG'}>

                  {
                    row?.contactNoWithISD?.trim()
                      ? row?.contactNoWithISD?.trim()
                        ?.replace(/\s+/g, '')
                        ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                          if (p1) {
                            const countryCode = p1;
                            const lastDigits = p2?.slice(-10);
                            return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                          }
                          return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                        })
                      : ''
                  }
                </Typography>
                <CopyToClipboard text=
                  {
                    row?.contactNoWithISD?.trim()
                      ? row?.contactNoWithISD?.trim()
                        ?.replace(/\s+/g, '')
                        ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                          if (p1) {
                            const countryCode = p1;
                            const lastDigits = p2?.slice(-10);
                            return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                          }
                          return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                        })
                      : ''
                  }
                  onCopy={() => setPhoneCopy(true)}>
                  <Iconify
                    icon="radix-icons:copy"
                    color={phoneCopy ? 'text.secondary' : 'text.textG'}
                    sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                    hover
                  />
                </CopyToClipboard>
              </Stack>
            ) : (
              <Typography sx={{ textTransform: 'lowercase' }} color={'text.textG'}>
                -
              </Typography>
            )}
          </TableCell>

          <TableCell sx={{ py: 0 }}>
            <Typography sx={{ maxwidth: 170, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.location || '-'}</Typography>
            <Typography sx={{ maxwidth: 170, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.domain || '-'}</Typography>
            <Typography sx={{}} color={'text.textG'}>
              {row.employeeNo || '-'}
            </Typography>
          </TableCell>
          <TableCell >
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}
              onClick={(e) => handleOpenn1()}
            >
              <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
              <Typography
                sx={{ color: 'text.secondary', cursor: 'pointer', py: 0 }}
              // onClick={(e) => handleOpenn()}
              >
                {row.notes.length ? `+${row.notes.length}` : ''}
                {/* {row.clients ? `+ ${row.clients}` : ''} */}
              </Typography>
            </Stack>
          </TableCell>
          <TableCell sx={{ py: 0 }}>
            <Stack sx={{ flexDirection: 'row' }}>
              <Typography sx={{}}>{row.currentStatus}</Typography>

              {/* <Box sx={{ paddingTop: 1.5 }}> */}
              <Iconify
                icon="bx:edit"
                sx={{ width: 15, height: 15 }}
                style={{ cursor: 'pointer' }}
              // onClick={(e) => setOpens(true)}
              />
              {/* </Box> */}

            </Stack>

            <Typography sx={{}}>-</Typography>
            <Typography sx={{}} color={'text.textG'}>
              {row.addedBy ? row.addedBy : "-"}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography sx={{ color: 'text.secondary', cursor: 'pointer', fontWeight: "bold" }} onClick={() => handleOpenDeleteModal('restore')}>Restore</Typography>
            <Typography sx={{ color: "red", cursor: 'pointer' }} onClick={() => handleOpenDeleteModal('delete')}>Delete</Typography>
            <Typography>-</Typography>
          </TableCell>
        </TableRow>
      ) : ["benchprospect", "benchsubmission"].includes(filterTab) ? (
        <TableRow

          key={row._id}
          sx={[
            { background: index % 2 === 0 ? 'text.background' : tablebg },
            { '&:last-child td, &:last-child th': { border: 0 } },
            { '&:hover': { boxShadow: 5 } },
          ]}
        >
          {filterTab === 'benchprospect' && (
            <TableCell sx={{ py: 0 }}>
              <Stack sx={{ flexDirection: "row" }}>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked1 || false}
                      onChange={() => selectCheckBox(row?._id)}
                    />
                  }
                  label=""
                />

                <Stack sx={{ flexDirection: "column", ml: -2 }}>
                  <Typography sx={{}} >

                    Up - {`${new Date(row.updatedAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(row?.updatedAt)?.getHours())?.padStart(2, '0')}`}:{`${String(new Date(row?.updatedAt)?.getMinutes())?.padStart(2, '0')}`}
                  </Typography>

                  <Typography sx={{}}>
                    Cr - {`${new Date(row.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(row?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(row?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                  </Typography>
                  <Typography>-</Typography>
                </Stack>
              </Stack>
            </TableCell>
          )}

          {filterTab === 'benchsubmission' && (
            <TableCell sx={{ py: 0 }}>
              <Stack sx={{ flexDirection: "row" }}>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked1 || false}
                      onChange={() => selectCheckBox(row?._id)}
                    />
                  }
                  label=""
                />
                <Stack sx={{ flexDirection: "column", ml: -2 }}>

                  <Typography sx={{}}>

                    Cr - {`${new Date(row.createdAt).toLocaleString('en-US', optionsDate)} 
    ${String(new Date(row?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(row?.createdAt).getMinutes()).padStart(2, '0')}`}
                  </Typography>

                  <Typography> -</Typography>
                  <Typography> -</Typography>
                </Stack>
              </Stack>
            </TableCell>
          )}

          <TableCell sx={{ py: 0 }}>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              {row.activeStatus === 'inactive' || row.status === 'backout' ? (
                <Typography
                  sx={{ fontWeight: '600', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.9rem' }}
                  color={'red'}
                // onClick={() =>
                //   navigate('/benchresumedetails', {
                //     state: {
                //       addedSkills,
                //       row,
                //       mtab: 'Resume',
                //       fTab:
                //         filterTab === 'worksheet'
                //           ? 'submitted'
                //           : '' || filterTab === 'favourites'
                //             ? 'submitted'
                //             : '' || filterTab === 'interview'
                //               ? 'placement'
                //               : '' || filterTab === 'placement'
                //                 ? 'start'
                //                 : '',
                //     },
                //   })
                // }
                >

                  {row.fullName}
                </Typography>
              ) : (filterTab === 'benchprospect' && row.status === 'started') || row.status === 'placement' ? (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '0.9rem'
                  }}
                  color={'#2ECC71'}
                // onClick={() =>
                //   navigate('/benchresumedetails', {
                //     state: {
                //       addedSkills,
                //       row,
                //       mtab: 'Resume',
                //       fTab:
                //         filterTab === 'worksheet'
                //           ? 'submitted'
                //           : '' || filterTab === 'favourites'
                //             ? 'submitted'
                //             : '' || filterTab === 'interview'
                //               ? 'placement'
                //               : '' || filterTab === 'placement'
                //                 ? 'start'
                //                 : '',
                //     },
                //   })
                // }
                >
                  {row.fullName}
                </Typography>
              ) : (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '0.9rem'
                  }}
                  color={'text.secondary'}
                // onClick={() =>
                //   // navigate('/resumeDetail', {
                //   navigate('/benchresumedetails', {
                //     state: {
                //       addedSkills,
                //       row,
                //       mtab: 'Resume',
                //       fTab:
                //         filterTab === 'worksheet'
                //           ? 'submitted'
                //           : '' || filterTab === 'favourites'
                //             ? 'submitted'
                //             : '' || filterTab === 'interview'
                //               ? 'placement'
                //               : '' || filterTab === 'placement'
                //                 ? 'start'
                //                 : '',
                //     },
                //   })
                // }
                >
                  {(row.fullName) ? row.fullName : "#"}
                </Typography>
              )}
              <Iconify
                icon="devicon:linkedin"
                color={'text.textG'}
                // color={row.linkedinUrl ? 'text.textG' : 'text.disabled'}

                sx={{
                  m: 0.3, height: 15, width: 15, cursor: 'pointer',
                }}
                hover
                onClick={() => window.open(row.linkedinUrl, '_blank')}

              />

              <Iconify
                icon="cuida:document-text-outline"
                color="#1E74B3"
                sx={{
                  ml: 0.6, height: 18, width: 18,
                  cursor: 'pointer'
                }}
                hover
                onClick={() => openResume(row?.resumeFile?.resumeFileUrl)}

              />

            </Stack>

            <>
              <Typography sx={{ width: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row?.jobTitle ? row?.jobTitle : '-'}

              </Typography>
              <Typography sx={{ width: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'text.textG'}>
                {/* {row.currentCompany ? row.currentCompany : '-'} */}
                {(row?.currentCompany || '').trim() || '-'}
              </Typography>
            </>

          </TableCell>

          <TableCell sx={{ py: 0 }}>

            <>
              {row.phone ? (
                <Stack sx={{ flexDirection: 'row' }}>
                  <Typography sx={{ flexDirection: 'row', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {/* {row.phone} */}
                    {/* {row?.phone?.replace(/(\d{3})(?=\d)/g, '$1 ').trim()} */}
                    {
                      row?.phone?.trim()
                        ? row?.phone?.trim()
                          ?.replace(/\s+/g, '')
                          ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                            if (p1) {
                              const countryCode = p1;
                              const lastDigits = p2?.slice(-10);
                              return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                            }
                            return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                          })
                        : ''
                    }
                  </Typography>
                  {row.phone && (

                    <CopyToClipboard text=
                      {
                        row?.phone?.trim()
                          ? row?.phone?.trim()
                            ?.replace(/\s+/g, '')
                            ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                              if (p1) {
                                const countryCode = p1;
                                const lastDigits = p2?.slice(-10);
                                return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                              }
                              return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                            })
                          : ''
                      }
                      onCopy={() => setPhoneCopy(true)}>
                      <Iconify
                        icon="radix-icons:copy"
                        color={phoneCopy ? 'text.secondary' : 'text.textG'}
                        sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                        hover
                      />
                    </CopyToClipboard>
                  )}
                </Stack>
              ) : (
                <Typography>-</Typography>
              )}
              {row.email ? (
                <Stack sx={{ flexDirection: 'row' }}>
                  <Typography
                    sx={{ maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', textTransform: 'none' }}
                  >
                    {row.email}
                  </Typography>
                  {row.email && (

                    <CopyToClipboard text={row.email} onCopy={() => setEmailCopy(true)}>
                      <Iconify
                        icon="radix-icons:copy"
                        color={emailCopy ? 'text.secondary' : 'text.textG'}
                        sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                      />
                    </CopyToClipboard>
                  )}
                </Stack>
              ) : (
                <Typography>-</Typography>
              )}

              {row.country ? (
                <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <Typography sx={{}} color={'text.textG'}>
                    {row.cityOrZipcode ? row.cityOrZipcode : '-'}
                  </Typography>
                  <Typography sx={{}} color={'text.textG'}>
                    {", "}{row.stateCode ? row.stateCode : ''}
                  </Typography>
                  {row.reallocate === 'yes' ? (
                    <Iconify icon="mdi:aeroplane" fontSize={20} color={'text.secondary'} />
                  ) : ''}
                </Stack>
              ) : (
                <Typography color={'text.textG'}>-</Typography>
              )}
            </>

          </TableCell>

          <>
            <TableCell sx={{ width: 170 }}>
              {row.skill && row.skill.length > 0 ? (
                <Grid container sx={{ maxWidth: 160, height: 44, overflow: 'hidden', textOverflow: 'ellipsis', gap: 0.3 }}>
                  {row.skill?.map((item, index) => (
                    item && (
                      <Typography key={index} sx={{}}>
                        {item}
                        {index < row.skill?.filter(skill => skill).length - 1 && ' | '}
                      </Typography>
                    )
                  ))}
                </Grid>
              ) : (
                <Typography>-</Typography>
              )}
              {row.skill && row.skill.length > 0 ? (
                <Typography
                  sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => {
                    setNewSkill(row.skill)
                    handleOpens11();
                  }}

                >
                  view all
                </Typography>
              ) : null}
            </TableCell>
          </>

          <TableCell sx={{ py: 0, width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>

            <Box sx={{ display: 'flex', alignItems: 'center', mt: -0.6, color: 'text.secondary' }}>
              <Typography sx={{ paddingRight: 1 }}>
                {row.visaType ? row.visaType : '-'}
              </Typography>
              {row.visaTransfer === "yes" ? (
                <Iconify icon="fluent:arrow-swap-16-filled" width="1.1rem" />
              ) : null}
            </Box>

            <Typography sx={{}}>
              {/* {row.validity ? dayjs(row.validity).format('D MMM YYYY') : '-'} */}
              {row.validity ? (
                <>
                  Validity - {moment(row.validity).format('ll')}
                </>
              ) : (
                "-"
              )}

            </Typography>
            {/* ):(
  "-" */}
            {/* ) } */}
            {filterTab === 'placement' ? (
              <Typography sx={{}}>
                {row.offeredJob && (row.annualSalary || row.hourlyRateRateOffered) ? (
                  <>
                    ${row.offeredJob === 'fulltime' ? row.annualSalary : row.hourlyRateRateOffered}
                    {row.chargeType === 'hourly' ? '/Hour' : 'K'}
                  </>
                ) : (
                  '-'
                )}
              </Typography>
            ) : (
              <Stack sx={{ flexDirection: 'row' }}>
                <Typography sx={{}}>
                  {row.expectedCompensation ? (
                    <>
                      ${row.expectedCompensation}
                      {row.chargeType === 'hourly' ? '/Hour' : 'K'}
                    </>
                  ) : (
                    '-'
                  )}
                </Typography>
                <Typography sx={{ ml: 0.5, textTransform: "capitalize" }} color={'text.textG'}>
                  {row.taxTerm ? row.taxTerm : ''}
                </Typography>
              </Stack>
            )}

          </TableCell>
          <TableCell>
            <>

              <Typography sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer', mt: -0.6 }}
                onClick={() => handleOpenclient1(row)}>

                Summary
              </Typography>

              <Typography>{"Exp - "}{row.experienceInYear}{" Yrs"}</Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                {/* {dayjs(row.DOB).format('MMM/DD/YYYY')} */}
                {row.DOB ? (
                  <>
                    D.O.B - {moment(row.DOB).format('ll')}
                  </>
                ) : (
                  '-'
                )}
              </Typography>
            </>

          </TableCell>
          <TableCell sx={{ py: 0, width: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}>

            {filterTab === 'benchprospect' ? (
              // <Typography sx={{}}>{row.status}</Typography>
              <Typography sx={{ color: 'text.secondary', fontWeight: "bold", cursor: 'pointer' }}
                onClick={() => { handleOpens1(row._id, row.activeStatus) }}>
                {row.activeStatus}</Typography>
            ) : null}

            {filterTab === 'submitted' ? (
              <Typography sx={{
                color: 'text.secondary',
                textDecoration: row.status === "submitted" ? 'underline' : '', mt: -0.8,
                cursor: 'pointer'
              }} onClick={() => {
                // if (row.submitStatus === "submitted") {
                if (row.status === "submitted") {
                  setLevelM(true)
                }
              }}>
                {/* {row.stepWiseStatus} */}
                {row.submitSubStatus !== "" && row.status === "submitted" ? row.submitSubStatus : row.status}
                {/* {row.status} */}
              </Typography>
            ) : null}

            {/* <Typography>jjj</Typography> */}

            <Stack sx={{ flexDirection: 'row', gap: 0.5 }}>
              <Typography sx={{}} >
                {/* {row.jobId} */}
                {/* {row.status} */}
              </Typography>
              <Stack sx={{ flexDirection: 'row' }} onClick={(e) => getClientsBench()}>
                <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
                <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>

                  {row.clients ? `+${row.clients}` : ''}
                </Typography>
              </Stack>
            </Stack>

            <Stack sx={{ flexDirection: "row" }}>

              <Typography sx={{}} color={'text.textG'}>
                {row.contactPersonName ? row.contactPersonName : '-'}
              </Typography>


            </Stack>

            {/* <Typography>-</Typography> */}
          </TableCell>

          <TableCell>
            <Typography sx={{ color: 'text.secondary', cursor: 'pointer', fontWeight: "bold" }} onClick={() => handleOpenDeleteModal('restore')}>Restore</Typography>
            <Typography sx={{ color: "red", cursor: 'pointer' }} onClick={() => handleOpenDeleteModal('delete')}>Delete</Typography>
            <Typography>-</Typography>
          </TableCell>

        </TableRow>
      ) : filterTab === "company" ? (
        <TableRow key={row._id}>
          <TableCell sx={{ pl: 1 }}>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>

              <FormControlLabel
                control={
                  <Checkbox
                    sx={{ mb: -0.8 }}
                    checked={checked1 || false}
                    onChange={() => selectCheckBox(row?._id)}
                  />
                }
                label=""
              />
              <Avatar sx={{ cursor: 'pointer', ml: -1.8 }} src={row?.companyLogo} alt="photoURL" />

              <Typography color={'text.secondary'}
                sx={{
                  cursor: 'pointer', ml: 1,
                  color: row.status === "inactive" ? "red" : ''
                }}

              >
                {row.companyName}
              </Typography>

            </Stack>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>

            <span>{row.officialDomain}</span>

          </TableCell>
          <TableCell sx={{ pl: 2 }}>
            <Typography sx={{ cursor: "pointer" }}
            >{row?.totalUserCount}</Typography>
          </TableCell>
          <TableCell sx={{ pl: 1 }}>
            <Typography sx={{ cursor: "pointer", color: 'text.secondary' }}
              onClick={() => handleOpenDeleteModal('restore')}>Restore</Typography>
            <Typography sx={{ cursor: "pointer", color: "red" }}
              onClick={() => handleOpenDeleteModal('delete')}>Delete</Typography>
          </TableCell>
        </TableRow>
      ) : (
        null 
      )}

      <Modal open={deleteModalOpen} onClose={handleCloseDeleteModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '50%', md: '40%' },
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            bgcolor: 'background.paper',
          }}
        >
          <Typography variant="h6" color = {sts === "delete" ? "red" :" #3C6BA5"} textAlign="center">
            Are you sure you want to {sts} this data?
          </Typography>  

          <Stack
            flexDirection={{ xs: 'column', md: 'row' }}
            gap={2}
            mt={2}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={() => commonDelete(row?._id)}
            >
              Yes
            </Button>
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={handleCloseDeleteModal}
            >
              No
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={openn1} onClose={handleClosen1} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset, { width: '70%' }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Activities
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Stack sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}>
              <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography sx={{ width: '21%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }} color={'text.secondary'}>
                  Date
                </Typography>
                <Typography sx={{ width: '15%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }} color={'text.secondary'}>
                  User
                </Typography>
                <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }} color={'text.secondary'}>
                  Status
                </Typography>
                <Typography sx={{ width: '55%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }} color={'text.secondary'}>
                  Note
                </Typography>
              </Stack>
            </Stack>
            {row.notes?.length &&
              row.notes?.slice(0)?.reverse()?.map((item, index) => {
                // row.notes?.map((item, index) => {
                return (
                  <Stack
                    sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                    ]}
                  >
                    <Typography sx={{ width: '21%' }}>
                      {item?.createdAt
                        ? `${new Date(item.createdAt)?.toLocaleString('en-US', optionsDate)} 
       ${new Date(item.createdAt)?.getHours()}:${new Date(item.createdAt)?.getMinutes()}`
                        : '-'}
                    </Typography>
                    <Typography sx={{ width: '15%', color: 'text.secondary', textTransform: 'capitalize', fontWeight: '600' }}>{item.noteBy}</Typography>
                    {item.status === 'dnc' ? (
                      <Typography sx={{ width: '25%' }}>DNC</Typography>
                    ) : null}
                    {item.status === 'passiveclient' ? (
                      <Typography sx={{ width: '25%' }}>Passive Client</Typography>
                    ) : null}
                    {item.status !== 'dnc' && item.status !== 'passiveclient' ? (
                      <Typography sx={{ width: '25%' }}>{item.status}</Typography>
                    ) : null}
                    <Typography sx={{ width: '55%', textTransform: 'capitalize' }}>
                      {/* <div dangerouslySetInnerHTML={{ __html: item.note }}/>
                       */}

                      {item.note}
                    </Typography>
                  </Stack>
                );
              })}
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openR} onClose={closeResume} style={{ borderRadius: 10 }}>
        <Box sx={styleClients1}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              mt: -2.5,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                color: 'text.secondary',
                fontWeight: 'bold',
                flex: 1,
                mb: 1,
                mt: 1,
              }}
            >
              Resume
            </Typography>
            <a href={openRes} download>
              <Iconify icon="mdi:download" width="1.3rem" color="text.secondary" />
            </a>
          </Box>
          <Scrollbar
            sx={{
              height: '97%',
              Scrollbar: 'thin',
              border: '2px solid #3C6BA5',
              borderColor: 'text.secondary',
              borderRadius: 2,
            }}
          >
            <Stack sx={{ p: 1.5 }}>

              <Box sx={{ overflowX: 'auto', minWidth: '600px' }}>
                <iframe title="resume" src={suru + openRes + lll} width="100%" height="700px" />
              </Box>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={opens} onClose={handleCloses} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset11}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: { xs: "center", sm: "space-between" },
              width: "100%",
              position: "relative",
              textAlign: "center",
            }}
          >

            <Typography
              variant="h5"
              color="#3C6BA5"
              sx={{
                position: { sm: "absolute" },
                left: { sm: "50%" },
                transform: { sm: "translateX(-50%)" },
                mb: { xs: 1, sm: 3 },
                mt: 3,
              }}
            >
              Skills
            </Typography>
          </Box>

          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 0.5,
                flexWrap: 'wrap'
              }}
            >

              {newSkill?.filter(item => item !== '' && item != null)?.map((item, index) => (
                item && (
                  <Box
                    key={index}
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="text.textG"
                      textAlign="center"
                      textTransform="capitalize"
                      sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                    >
                      {item} {index < row.skill.length - 1 && '|'}

                    </Typography>
                  </Box>
                )
              ))}

            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openn} onClose={handleClosen} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          <Typography variant="h5" color={'#3C6BA5'} sx={{ textTransform: 'capitalize', mt: -3 }} textAlign={'center'}>
            Notes
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
            <Stack sx={{ backgroundColor: 'text.secondary', flexDirection: 'row', p: 1, py: 0.5, borderRadius: 1, minWidth: 600 }}>
              <Typography color={'white'} sx={{ width: '20%', fontSize: '0.976rem', fontWeight: '600' }}>
                Date
              </Typography>
              <Typography color={'white'} sx={{ width: '20%', fontSize: '0.976rem', fontWeight: '600' }}>
                User
              </Typography>
              <Typography color={'white'} sx={{ width: '60%', fontSize: '0.976rem', fontWeight: '600' }}>
                Note
              </Typography>
            </Stack>

            {his.length
              ? his.map((item, index) => {
                return (
                  <Stack
                    key={index}
                    sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { flexDirection: 'row', p: 1, minWidth: 600 },
                    ]}
                  >
                    <Typography sx={{ width: '20%' }}>
                      {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                    </Typography>
                    <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
                      {item.actionBy}
                    </Typography>
                    <Box sx={{ width: '60%', overflowX: 'auto' }}>
                      <div
                        dangerouslySetInnerHTML={{ __html: item?.note }}
                        style={{
                          lineHeight: '1.6',
                          fontSize: '1rem',
                          whiteSpace: 'pre-wrap',
                        }}
                      />
                    </Box>
                  </Stack>
                );
              })
              : null}
          </Box>
        </Box>
      </Modal>

      <Modal open={openclient} onClose={handleCloseclient} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Activities
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, overflowX: 'auto' }}>
            <Box sx={{ minWidth: 600 }}>
              <Stack sx={{ alignItems: 'center' }}>
                <Stack
                  sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
                >
                  <Stack
                    sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                  >
                    <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Date
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      User Name
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Job ID
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Client
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Job Title
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Status
                    </Typography>
                  </Stack>
                </Stack>

                {client
                  ? client.map((item, index) => {
                    return (
                      <Stack
                        key={index}
                        sx={[
                          { background: index % 2 === 0 ? 'text.background' : tablebg },
                          { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                        ]}
                      >
                        <Typography sx={{ width: '25%' }}>
                          {`${new Date(item.createdAt)?.toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
                          {item.actionBy}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.jobId ? item.jobId : '-'}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.clientName ? item.clientName : '-'}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.jobIdTitle || item.jobTitle}
                        </Typography>
                        <Typography
                          sx={[
                            {
                              color:
                                item.actionTo === 'started' || item.actionTo === 'placement'
                                  ? 'green'
                                  : item.actionTo === 'Backout from Job offer'
                                    ? 'red'
                                    : '',
                            },
                            { width: '20%', textTransform: 'capitalize' },
                          ]}
                        >
                          {item.actionTo}
                        </Typography>
                      </Stack>
                    );
                  })
                  : null}
              </Stack>
            </Box>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openclient1} onClose={handleCloseclient1}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: { xs: '90%', sm: '70%', md: '50%' },
            maxHeight: '90vh',
            overflowY: 'auto',
            bgcolor: 'white',
            p: 3,
            borderRadius: 2,
            mx: 'auto',
            mt: { xs: '10%', md: '5%' }
          }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            alignItems="center"
            sx={{ width: '100%' }}
          >

            <Typography
              variant="h5"
              color="#3C6BA5"
              textAlign="center"
              sx={{ flexGrow: 1 }}
            >
              Summary
            </Typography>

          </Stack>

          <Divider sx={{ mt: 1, mb: 1, borderWidth: 1.7, borderColor: '#3C6BA5' }} />

          <Typography
            sx={{
              width: '100%',
              fontSize: '0.976rem',
              fontWeight: '100',
              textAlign: 'center'
            }}
          >
            {updateSummary}
          </Typography>

        </Box>
      </Modal>

      <Modal open={opens11} onClose={handleCloses11} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset11}>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: { xs: "center", sm: "space-between" },
              width: "100%",
              position: "relative",
              textAlign: "center",
            }}
          >
            <Typography
              variant="h5"
              color="#3C6BA5"
              sx={{
                position: { sm: "absolute" },
                left: { sm: "50%" },
                transform: { sm: "translateX(-50%)" },
                mb: { xs: 1, sm: 3 },
                mt: 3,
              }}
            >
              Skills
            </Typography>

          </Box>
          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 0.5,
                flexWrap: 'wrap'
              }}
            >
              {newSkill?.filter(item => item !== '' && item != null)?.map((item, index) => (

                item && (
                  <Box
                    key={index}
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="text.textG"
                      textAlign="center"
                      textTransform="capitalize"
                      sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                    >
                      {item} {index < row.skill.length - 1 && '|'}

                    </Typography>
                  </Box>
                )
              ))}

            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openclient11} onClose={handleCloseclient11} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Activities
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack sx={{ alignItems: 'center' }}>
              <Stack sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}>
                <Stack
                  sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                >
                  <Typography sx={{ width: '22%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Date
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    User Name
                  </Typography>

                  <Typography sx={{ width: '18%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Client
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Job Title
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Rec Details
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Notes
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Status
                  </Typography>
                </Stack>
              </Stack>

              {clients11
                ? clients11.map((item, index) => {
                  // console.log('client list----------------------', item);
                  return (
                    <Stack
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                      ]}
                    >
                      <Typography sx={{ width: '21%' }}>
                        {/* {moment(`${item.createdAt}`).format('lll')} */}
                        {`${new Date(item.createdAt)?.toLocaleString('en-US', optionsDate)} 
                  ${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                      </Typography>
                      <Typography sx={{ width: '21%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
                        {item.actionBy}
                      </Typography>

                      <Typography sx={{ width: '18%', textTransform: 'capitalize' }}>
                        {item.clientName ? item.clientName : '-'}
                      </Typography>
                      <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                        {item.jobIdTitle || item.jobTitle}
                      </Typography>
                      <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                        {item.recruitorName ? item.recruitorName : '-'} <br />
                        {item.recruitorNumber ? item.recruitorNumber : '-'}
                      </Typography>
                      <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                        {item.note}
                      </Typography>
                      <Typography
                        sx={[
                          {
                            color:
                              item.actionTo === 'started' || item.actionTo === 'placement'
                                ? 'green'
                                : item.actionTo === 'Backout from Job offer'
                                  ? 'red'
                                  : '',
                          },
                          { width: '20%', textTransform: 'capitalize' },
                        ]}
                      >
                        {item.actionTo}
                      </Typography>
                    </Stack>
                  );
                })
                : null}
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
    </>
  );
}
